<template>
  <div class="page">
    <sui-segment class="content" padded attached emphasis="secondary">
      <sui-container>
        <h2 class="ui header">
          <i class="user circle grey icon" />
          <sui-header-content>Account</sui-header-content>
        </h2>
        <sui-menu class="big" attached="top" color="blue" :widths="visibleSections.length">
          <router-link class="item" :class="{active: $route.path === section.path}" :to="section.path" v-for="section in visibleSections" :key="section.path">
            <i class="icon" :class="section.icon" />{{section.text}}
          </router-link>
        </sui-menu>
        <router-view />
      </sui-container>
    </sui-segment>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    name: 'AccountView',
    computed: {
      ...mapGetters(['config', 'accounts', 'members', 'roles', 'keys', 'providers']),
      sections() {
        return [
          { path: '/account/accounts', icon: 'user circle', text: `Accounts (${this.accounts.length})` },
          { path: '/account/members', icon: 'users', text: `Members (${this.members.length})` },
          { path: '/account/roles', icon: 'tags', text: `Roles (${this.roles.length})` },
          { path: '/account/keys', icon: 'key', text: `Keys (${this.keys.length})` },
          { path: '/account/providers', icon: 'cloud', text: `Providers (${this.providers.length})` },
        ]
      },
      visibleSections() {
        return this.sections.filter(section => !section.hidden)
      },
    },
  }
</script>

<style scoped>
  .page { display: flex; flex-direction: column; }
  .header { display: flex; align-items: center; justify-content: space-between; }
  .content { flex: 1; }
  .menu .item .icon { margin: 0 .3em 0 0!important; }
</style>
